import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { Modal, Button } from "@mui/material";
import { toast } from "react-toastify";
import {
  addStudent,
  get_hostel_type_from_udise,
  get_school_name_gmid,
  get_category_for_student,
  get_sub_category_for_student_by_caste,
  getAllBlocksFromDistrict,
  getVillageFromGpBlockAndDistrict,
  getGPFromDistrictAndBlock,
  newNotice,
} from "../api/Users";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../api/constant";
import { MDBTypography } from "mdb-react-ui-kit";
import adhaarImg from "../images/adhaar.png";
import { Image } from "react-bootstrap";

const AddNotice = ({ userData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [loading, setLoading] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [notice, setNotice] = useState({
    heading: "",
    body: "",
    doc: "",
    photos: "",
    category: "",
    start_date: "",
    end_date: "",
    HM: false,
    WEO: false,
    DWO: false,
    DM: false,
    student: false,
    teacher: false,
  });

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const handleChangeInput = (e) => {
    const { name, value, type, files, checked } = e.target;
    if (type !== "file") {
      if (type === "checkbox") {
        if (name === "all") {
          setNotice((prevNotice) => ({
            ...prevNotice,
            HM: checked,
            WEO: checked,
            DWO: checked,
            DM: checked,
            student: checked,
            teacher: checked,
            [name]: checked,
          }));
        } else {
          setNotice((prevNotice) => ({ ...prevNotice, [name]: checked }));
        }
      } else {
        setNotice((prevNotice) => ({ ...prevNotice, [name]: value }));
      }

      if (name === "start_date" && notice.end_date && value > notice.end_date) {
        setNotice((prevNotice) => ({ ...prevNotice, end_date: "" }));
      }
    } else {
      const file = files[0];
      setNotice((prevNotice) => ({ ...prevNotice, [name]: file }));
    }
  };

  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();

    formData.append("notice_text", notice.heading);
    formData.append("notice_attachment", notice.doc);
    formData.append("user_id", `${userData.data.id}`);
    formData.append("role_id", `${userData.data.role_id}`);
    formData.append("notice_photo", notice.photos);
    formData.append("category", notice.category);
    formData.append("start_date", notice.start_date);
    formData.append("expiry_date", notice.start_date);
    formData.append("notice_body", notice.body);
    formData.append("is_active", 1);

    const selectedRoles = [];
    if (notice.HM) selectedRoles.push("4");
    if (notice.WEO) selectedRoles.push("5");
    if (notice.DWO) selectedRoles.push("6");
    if (notice.DM) selectedRoles.push("7");
    if (notice.teacher) selectedRoles.push("9");
    if (notice.student) selectedRoles.push("10");

    const rolesString = selectedRoles.join(",");
    formData.append("notice_access_roles", rolesString);

    newNotice(formData)
      .then((res) => {
        if (res.status === "success") {
          setIsLoading(false);
          setLoading(100);
          toast.success(t(res.message));
          navigate(`/add-notice`);
          setNotice({
            heading: "",
            file: "",
            start_date: "",
            end_date: "",
            HM: false,
            WEO: false,
            DWO: false,
            DM: false,
            student: false,
            teacher: false,
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          toast.error(t(res.message));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Add Notice Details")}</h5>
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row col-12">
            <div
              className="row col-8 p-5"
              style={{ borderRight: "1px solid gray" }}
            >
              <div className="col-md-6">
                <label className="form-label">
                  {t("Heading")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="text"
                  name="heading"
                  value={notice.heading}
                  className="form-control"
                  onChange={handleChangeInput}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  {t("Category")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <select
                  name="category"
                  value={notice.category}
                  className="common-input form-select"
                  onChange={handleChangeInput}
                  required
                >
                  <option value="">Select Category</option>
                  <option value="Suggestion">Suggestion</option>
                  <option value="Achievement">Achievement</option>
                </select>
              </div>
              <div className="col-md-12">
                <label className="form-label">
                  {t("Body")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <textarea
                  name="body"
                  value={notice.body}
                  className="form-control"
                  onChange={handleChangeInput}
                  required
                />
              </div>
              <div className="col-md-4 mt-4">
                <label className="form-label">
                  {t("Documents")}
                  <span className="text-danger"> *</span>
                </label>
                <input
                  type="file"
                  name="doc"
                  className="form-control"
                  onChange={handleChangeInput}
                  accept=".pdf"
                  required
                />
              </div>
              <div className="col-md-4 mt-4">
                <label className="form-label">
                  {t("Photos")}
                  <span className="text-danger"> *</span>
                </label>
                <input
                  type="file"
                  name="photos"
                  className="form-control"
                  onChange={handleChangeInput}
                  accept=".jpg, .jpeg, .png"
                  required
                />
              </div>
              <div className="col-md-4 mt-4">
                <label className="form-label">
                  {t("Issue Date")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="date"
                  name="start_date"
                  value={notice.start_date}
                  className="form-control"
                  onChange={handleChangeInput}
                  required
                  min={new Date().toISOString().split("T")[0]}
                />
              </div>
              {/* <div className="col-md-6 mt-4">
                <label className="form-label">
                  {t("End Date")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="date"
                  name="end_date"
                  value={notice.end_date}
                  className="form-control"
                  onChange={handleChangeInput}
                  min={notice.start_date}
                  required
                />
              </div> */}
            </div>
            <div className="col-4 p-5 pt-3 row">
              <h5 className="col-md-12 d-flex justify-content-between">
                {t("Select For Roles")}:
              </h5>
              <div className="mt-2">
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2 fw-bold">
                      {t("Select All")}:
                    </label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="all"
                      checked={notice.all}
                      onChange={handleChangeInput}
                    />
                  </div>
                  {/* <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("Student")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="student"
                      checked={notice.student}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("Teacher")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="teacher"
                      checked={notice.teacher}
                      onChange={handleChangeInput}
                    />
                  </div> */}
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("HM")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="HM"
                      checked={notice.HM}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("WEO")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="WEO"
                      checked={notice.WEO}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DWO")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DWO"
                      checked={notice.DWO}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DM")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DM"
                      checked={notice.DM}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row col-12 mt-5 d-flex justify-content-end">
            <button type="submit" className="btn btn-primary me-2 col-md-2">
              {t("Save")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddNotice;
